import React from 'react';

import { Typography } from '@mui/material';

import LengthsOfStay from '~/components/Vendors/Properties/LengthsOfStay';

import { useGetRoomRateLengthsOfStay } from '~/hooks/apis/reservation/useGetRoomRateLengthsOfStay';

interface Props {
  propertyId: string;
  roomType: App.RoomType;
  roomRate: App.RoomRate;
}

export default function LengthsOfStayTab({ propertyId, roomType, roomRate }: Props) {
  const { data: lengthsOfStay = [] } = useGetRoomRateLengthsOfStay(propertyId, roomType.id, roomRate.id);

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Length-of-stay restrictions by arrival date. Applies to channel-managed Flash offers only, so this view is
        read-only.
      </Typography>

      <LengthsOfStay lengthsOfStay={lengthsOfStay} />
    </>
  );
}
